import ButtonCustom from '@/components/ButtonCustom/ButtonCustom'
import { SizeButton } from '@/constants/sizeButton'
import { KIND } from 'baseui/button'
import React, { useState } from 'react'

const GRADIENT =
  'linear-gradient(94deg, #FF1866 -4.37%, #FD0167 23.84%, #F00188 47.41%, #DD01A0 63.41%, #D203B4 74.42%, #C811CB 100%)'
const ACTIVE_GRADIENT = `linear-gradient(rgba(0,0,0,0.12), rgba(0,0,0,0.12)), ${GRADIENT}`
const HOVER_SHADOW = '0px 0px 20px 0px rgba(255, 5, 96, 0.50)'

interface Props {
  onClick: () => void
  children: JSX.Element | JSX.Element[] | string
  startEnhancer?: JSX.Element
  disabled?: boolean
}

function GradientButton({ onClick, children, startEnhancer, disabled }: Props) {
  const [hovered, setHovered] = useState(false)

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ButtonCustom
        type={SizeButton.LARGE}
        kind={KIND.primary}
        onClick={onClick}
        disabled={disabled}
        style={{
          background: GRADIENT,
          boxShadow: hovered ? HOVER_SHADOW : 'none',
          transition: 'box-shadow 0.15s ease',
          ':active': {
            background: ACTIVE_GRADIENT,
          },
        }}
        startEnhancer={startEnhancer}
      >
        {children}
      </ButtonCustom>
    </div>
  )
}

export default GradientButton
